<div class="control-dus-page" *ngIf="dus; else loadingOrError">
  <!-- Main Card Content -->
  <div class="main-card">
    <!-- DUS Header -->
    <div class="order-header">
      <div class="header-content">
        <div class="header-left">
          <button mat-icon-button (click)="volver()" aria-label="Volver" class="back-btn">
            <mat-icon>arrow_back</mat-icon>
          </button>
          <div class="order-title">
            <p>Control DUS</p>
            <h1>Nro. I/E {{ padNumber(dus.nroIE) }}</h1>
          </div>
        </div>

        <div class="header-right">
          <button mat-raised-button color="primary" (click)="exportarReporteGuias()"
            [disabled]="isGeneratingReporteGuias"
            [matTooltip]="isGeneratingReporteGuias ? 'Generando reporte...' : 'Descargar Reporte de Guías de Despacho'">
            <mat-icon>{{ isGeneratingReporteGuias ? 'hourglass_empty' : 'route' }}</mat-icon>
            {{ isGeneratingReporteGuias ? 'Generando...' : 'Reporte Guías' }}
          </button>
          <button mat-raised-button color="accent" (click)="verPackingLists()">
            <mat-icon>inventory_2</mat-icon>
            Ver Packing Lists
          </button>
        </div>
      </div>
    </div>

    <div class="content-area">
      <!-- === SECCIÓN 1: INFORMACIÓN BÁSICA === -->
      <div class="section-container">
        <div class="section-header">
          <div class="icon-box blue">
            <mat-icon>info</mat-icon>
          </div>
          <h2>Información Básica</h2>
        </div>

        <div class="info-grid">
          <div class="info-card">
            <span class="label">DUS</span>
            <p class="value font-bold font-mono">
              {{ dus.dus || '-' }}
            </p>
          </div>
          <div class="info-card">
            <span class="label">Despacho</span>
            <p class="value font-mono">{{ dus.despacho || '-' }}</p>
          </div>
          <div class="info-card">
            <span class="label">Reserva</span>
            <p class="value font-mono">{{ dus.reserva || '-' }}</p>
          </div>
          <div class="info-card">
            <span class="label">Ref. Cliente</span>
            <p class="value">{{ dus.refCliente || '-' }}</p>
          </div>
          <div class="info-card">
            <span class="label">Cliente</span>
            <p class="value font-bold">{{ dus.cliente || '-' }}</p>
          </div>
          <div class="info-card">
            <span class="label">Exportador</span>
            <p class="value">{{ dus.exportador || '-' }}</p>
          </div>
          <div class="info-card">
            <span class="label">Tipo Embarque</span>
            <p class="value with-icon">
              <mat-icon [class.text-amber]="
                                    dus.tipoEmbarque === 'Pallet'
                                " [class.text-blue]="
                                    dus.tipoEmbarque === 'Contenedor'
                                ">
                {{
                dus.tipoEmbarque === 'Pallet'
                ? 'inventory_2'
                : 'directions_boat'
                }}
              </mat-icon>
              {{ dus.tipoEmbarque || '-' }}
            </p>
          </div>
          <div class="info-card">
            <span class="label">Contenedor</span>
            <p class="value font-mono font-bold">
              {{ dus.contenedor || '-' }}
            </p>
          </div>
          <div class="info-card">
            <span class="label">PLTS</span>
            <p class="value font-mono">
              {{ formatearNumero(dus.plts) }}
            </p>
          </div>
          <div class="info-card">
            <span class="label">SPS</span>
            <p class="value font-mono">{{ dus.sps || '-' }}</p>
          </div>
          <div class="info-card">
            <span class="label">ISF</span>
            <p class="value font-mono">
              {{
              dus.isf ? (dus.isf | date : 'dd/MM/yyyy') : '-'
              }}
            </p>
          </div>
          <div class="info-card" *ngIf="dus.ejecutivo">
            <span class="label">Agente de Aduana</span>
            <p class="value font-bold">{{ dus.ejecutivo }}</p>
          </div>
        </div>
      </div>

      <!-- === SECCIÓN 2: PUERTOS Y FECHAS === -->
      <div class="ports-section" *ngIf="dus.pol || dus.pod || dus.etd || dus.eta">
        <div class="section-header">
          <div class="icon-box emerald">
            <mat-icon>place</mat-icon>
          </div>
          <h2>Puertos y Fechas</h2>
        </div>

        <div class="flow-container">
          <!-- POL -->
          <div class="port-item" *ngIf="dus.pol">
            <div class="icon-label">
              <mat-icon class="text-blue">place</mat-icon>
              <span>POL</span>
            </div>
            <p class="port-name">{{ dus.pol }}</p>
            <p class="terminal-name" *ngIf="dus.etd">
              ETD: {{ formatearFecha(dus.etd) }}
            </p>
          </div>

          <!-- Arrow -->
          <div class="flow-arrow" *ngIf="dus.pol && dus.pod">
            <mat-icon class="ship-icon">directions_boat</mat-icon>
            <mat-icon class="arrow-icon">arrow_forward</mat-icon>
          </div>

          <!-- POD -->
          <div class="port-item" *ngIf="dus.pod">
            <div class="icon-label">
              <mat-icon class="text-emerald">place</mat-icon>
              <span>POD</span>
            </div>
            <p class="port-name">{{ dus.pod }}</p>
            <p class="terminal-name" *ngIf="dus.eta">
              ETA: {{ formatearFecha(dus.eta) }}
            </p>
          </div>
        </div>

        <div class="info-grid" *ngIf="dus.etd && dus.eta" style="margin-top: 1.5rem">
          <div class="info-card">
            <span class="label">Días de Tránsito</span>
            <p class="value font-mono">
              {{ calcularDiasTransito(dus.etd, dus.eta) }}
            </p>
          </div>
        </div>
      </div>

      <!-- === SECCIÓN 3: INFORMACIÓN DE EMBARQUE === -->
      <div class="section-container" *ngIf="dus.nave || dus.viaje">
        <div class="section-header">
          <div class="icon-box amber">
            <mat-icon>directions_boat</mat-icon>
          </div>
          <h2>Información de Embarque</h2>
        </div>

        <div class="info-grid">
          <div class="info-card" *ngIf="dus.nave">
            <span class="label">Nave</span>
            <p class="value font-bold">{{ dus.nave }}</p>
          </div>
          <div class="info-card" *ngIf="dus.viaje">
            <span class="label">Viaje</span>
            <p class="value font-mono">{{ dus.viaje }}</p>
          </div>
        </div>
      </div>

      <!-- === SECCIÓN 4: INFORMACIÓN ADUANERA === -->
      <div class="section-container">
        <div class="section-header">
          <div class="icon-box indigo">
            <mat-icon>description</mat-icon>
          </div>
          <h2>Información Aduanera</h2>
        </div>

        <div class="info-grid">
          <div class="info-card" *ngIf="dus.fechaAceptacion">
            <span class="label">Fecha de Aceptación</span>
            <p class="value font-mono">{{ dus.fechaAceptacion }}</p>
          </div>
          <div class="info-card">
            <span class="label">Estado</span>
            <p class="value">
              <span [class.text-blue]="dus.estado === 'En Proceso'" [class.text-emerald]="
                                    dus.estado === 'Finalizado'
                                " [class.text-amber]="dus.estado === 'Pendiente'">
                {{ dus.estado || '-' }}
              </span>
            </p>
          </div>
          <div class="info-card">
            <span class="label">Estado Aduana</span>
            <p class="value">{{ dus.estadoAduana || '-' }}</p>
          </div>
          <div class="info-card">
            <span class="label">Fecha Legalización</span>
            <p class="value font-mono">{{ dus.fechaLegalizacion || '-' }}</p>
          </div>
          <div class="info-card" *ngIf="dus.tipoAtraso && dus.estado === 'Pendiente'">
            <span class="label">Tipo de Atraso</span>
            <p class="value">{{ dus.tipoAtraso }}</p>
          </div>
        </div>
      </div>

      <!-- === SECCIÓN 5: INFORMACIÓN ADICIONAL === -->
      <div class="section-container" *ngIf="dus.comentarios">
        <div class="section-header">
          <div class="icon-box purple">
            <mat-icon>comment</mat-icon>
          </div>
          <h2>Comentarios</h2>
        </div>

        <div class="comments-content">
          <p>{{ dus.comentarios }}</p>
        </div>
      </div>
    </div>
    <!-- End Content Area -->
  </div>
  <!-- End Main Card -->
</div>
<!-- End Control DUS Page -->

<ng-template #loadingOrError>
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner diameter="50"></mat-spinner>
    <p>{{ loadingMessage }}</p>
  </div>
  <div *ngIf="error" class="error-container">
    <mat-icon color="warn">error</mat-icon>
    <p>{{ error }}</p>
    <button mat-raised-button color="primary" (click)="volver()">
      <mat-icon>arrow_back</mat-icon>
      Volver
    </button>
  </div>
</ng-template>